export const PLATE_SEEDS_CHANGED_EVENT = 'rm-plate-seeds-changed';

export function notifyPlateSeedsChanged(plateId?: number) {
  window.dispatchEvent(
    new CustomEvent(PLATE_SEEDS_CHANGED_EVENT, {
      detail: { plateId },
    }),
  );
}
